import React, {useState} from 'react';
import styles from "./header.module.sass"
import icon from "../../assets/map_icon.png"
import line from "../../assets/nav_line.png"
import {NavLink} from "react-router-dom"
import {DropdownList} from "./components/Dropdown";
import {DropdownListPhone} from "./components/DropDownPhone";
import logo from "../../assets/logo_black.png"
import {DropdownCity} from "./components/DropdownCity";


export const Header = () => {
    const scrollToElement = (id: string) => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <div className={styles.header__wrap}>
            <div className={styles.header}>
                <img className={styles.logo__hidden} src={logo} alt=""/>
                <div className={styles.header__logo__vv}>
                    <span>Ваше Величие</span>
                </div>
                <button onClick={() => scrollToElement('sectionMap')} className={styles.header__button__link}>
                <img className={styles.header__icon__map} src={icon} alt=""/>
                <span className={styles.header__navText__shop} >Магазины</span>
                </button>
                <img  className={styles.header__img__line} src={line} alt=""/>
                <button onClick={() => scrollToElement('sectionAbout')} className={styles.header__button__link}>
                    <span className={styles.header__navText__about} >Компания</span>
                </button>
                <button onClick={() => scrollToElement('sectionCatalog')} className={styles.header__button__link}>
                    <span className={styles.header__navText__catalog} >Каталог</span>
                </button>
                <button onClick={() => scrollToElement('sectionReview')} className={styles.header__button__link}>
                    <span className={styles.header__navText__review} >Отзывы</span>
                </button>
                <button onClick={() => scrollToElement('sectionOrder')} className={styles.header__button__link}>
                    <span className={styles.header__navText__order} >Сделать заявку</span>
                </button>
                <button onClick={() => scrollToElement('sectionOrder')}  className={styles.header__button__order}>
                    <span className={styles.header__buttonText__order}>Сделать заявку</span>
                </button>
                <DropdownListPhone></DropdownListPhone>
                <DropdownCity></DropdownCity>
                <div>
                    <DropdownList></DropdownList>
                </div>
            </div>
        </div>
    );
};